import { Pipe, PipeTransform } from "@angular/core";
import { FlightsService } from "../../flights-calendar/flights.service";

@Pipe({
    name: "flightOperation",
    standalone: false,
})
export class FlightOperationPipe implements PipeTransform {
    constructor(private _flightsService: FlightsService) {}

    transform(flightOperationIds: string): string {
        if (!flightOperationIds) {
            return "N/D";
        }
        const flightOperationsArray = this._flightsService.getFlightAttributesArray().flightOperations;
        const flightOperationIdsArray = flightOperationIds.split(",");
        let flightOp = "";
        // flightOperationIdsArray.map(id => {

        // });
        for (let i = 0; i < flightOperationIdsArray.length; i++) {
            const id = flightOperationIdsArray[i];
            flightOp += flightOperationsArray.filter((op) => op.id.toString() === id)[0].name;
            if (i < flightOperationIdsArray.length - 1) {
                flightOp += ", ";
            }
        }
        return flightOp === "" ? "N/D" : flightOp;
    }
}
